module.exports = __webpack_public_path__ + "static/img/top-tabs-title-pic1.cfbd2719.png";